export default __webpack_public_path__ + "static/4_Screenshot-974c93032244720177a8875020603bd0.png";